export const SELECTED_OPTIONS = 'selectedOptions'
export const SET = SELECTED_OPTIONS + '/SET'
